import "./CustomCheckbox.css";
import { ReactComponent as CheckIcon } from '../../../assets/icons/check-icon.svg';

export default function CustomCheckbox({ checked, onChange, disabled = false }) {
  return (
    <span className="checkbox-container" style={disabled ? { cursor: "default" } : { cursor: "pointer" }}>
      <input
        type="checkbox"
        style={disabled ? { cursor: "default" } : { cursor: "pointer" }}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        readOnly={disabled}
      />
      <span className="custom-checkbox" style={disabled ? { cursor: "default" } : { cursor: "pointer" }}>
        <CheckIcon width={16} height={16} color="#ffffff" style={{ opacity: checked ? 1 : 0}} />
      </span>
    </span>
  );
}
